

export interface IContainer {
    get: <T>(key: symbol) => T;
    bind: <T>(key: symbol, val: T) => void; 
}

export type ILazyBinder<T> = () => Promise<T>;

export function injectContainer(): IContainer {
    return (global as any).container as IContainer;
}

export function bindContainer(container: IContainer) {
    (global as any).container = container;
}

